import { IconSvg, IconSvgProps } from "./icon"

export default function LocationTarget(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12.002 15.935v4.5M12.002 3.56v4.5M8.064 11.998h-4.5M12 11.998l-.002.002M20.439 11.998h-4.5M5.814 11.998a6.188 6.188 0 1 0 12.376 0 6.188 6.188 0 0 0-12.376 0Z" />
    </IconSvg>
  )
}
